export default __webpack_public_path__ + "static/media/Folders.ba2710ea.svg";